import { combineReducers } from 'redux'
import { createActionThunk } from 'redux-thunk-actions'
import { createAction, handleActions } from 'redux-actions'
import { actions as toastr } from 'react-redux-toastr'
import _ from 'lodash'

import api from 'core/api'
import token_purchase_types from './token_purchase_types'
import { getDeposits } from 'modules/users/current/deposits'
import { getTokens } from 'modules/users/current/tokens'
import { getPricesDebounced as getCurrencies } from 'modules/calculations/prices'
import calculatorModule from 'modules/calculator'
import calculatorSelector from 'selectors/calculator'
import pricesSelector from 'selectors/prices'

const getType = type => `@contracts/${type}`

const generateContract = createActionThunk(
  getType('GENERATE'),
  api('/contracts', { method: 'POST' })
)

export const toggleContractDialog = createAction(getType('TOGGLE_DIALOG_OPENED'))

export const checkPurchaseAgreement = createAction(getType('CHECK_PURCHASE_AGREEMENT'))

export const toggleGenerateContract = buy_from_all_balance => (dispatch, getState) => {
  const state = getState()
  const { token_purchase_type_id } = getState().calculator.buy_tokens_form
  const { recalculate } = calculatorModule('buy_tokens_form', { getCurrencies })
  const calculator = calculatorSelector('buy_tokens_form', pricesSelector)(state)
  const { code: currency, coin_amount, coin_price } = calculator
  dispatch(
    generateContract({
      currency,
      coin_amount,
      coin_price,
      buy_from_all_balance,
      token_purchase_type_id,
      purchase_agreement: true
    })
  )
    .then(() => dispatch(toggleContractDialog()))
    .catch(res => {
      dispatch(toastr.add({ type: 'error', message: res.error.error.details }))
      dispatch(recalculate())
    })
}

export const buyTokensThunk = createActionThunk(getType('BUY_TOKENS'), (...rest) => {
  const { getState } = _.last(rest)
  const id = getState().contracts.index.json.id
  return api(`/contracts/${id}/buy_tokens`, { method: 'POST' })(...rest)
})

const getPlatformlUri = ({ protocol, host }) => `${protocol}//${host}/`

export const buyTokens = () => dispatch =>
  dispatch(buyTokensThunk({ platform_uri: getPlatformlUri(window.location) }))
    .then(res => {
      dispatch(toastr.add({ type: 'success', message: 'The purchase of tokens was successful' }))
      dispatch(toggleContractDialog())
      dispatch(getDeposits())
      dispatch(getTokens())
    })
    .catch(res => {
      dispatch(toastr.add({ type: 'error', message: res.error.error.details }))
      dispatch(toggleContractDialog())
    })

const initialState = { contract_dialog_opened: false, purchase_agreements: {} }

const reducer = handleActions(
  {
    [generateContract.START]: state => ({ ...state, loading: true }),
    [generateContract.SUCCEEDED]: (state, { payload }) => ({ ...state, ...payload }),
    [generateContract.FAILED]: (state, { payload }) => ({ ...state, ...payload }),
    [generateContract.ENDED]: state => ({ ...state, loading: false }),
    [toggleContractDialog]: state => ({
      ...state,
      contract_dialog_opened: !state.contract_dialog_opened
    }),
    [checkPurchaseAgreement]: (state, { payload }) => ({
      ...state,
      purchase_agreements: {
        ...state.purchase_agreements,
        ...payload
      }
    })
  },
  initialState
)

export default combineReducers({
  index: reducer,
  token_purchase_types
})



// WEBPACK FOOTER //
// ./src/modules/contracts/index.js